import { SpineFromOptions } from '@esotericsoftware/spine-pixi-v8';
import { TeamIdAndColorMap } from '@nova/configs';
import { BotPartSlot } from '@nova/types';

export type TeamColorAssignment = {
  name: string;
  colour: number[];
};

export type BotOptions = {
  teamColor?: TeamColorAssignment;
  /** When set, only these part skins are composed onto the bot skeleton. */
  visibleSlots?: BotPartSlot[];
  /** When false, eyes and lights attachments are cleared if the helmet slot is shown. Defaults to true. */
  includeHeadAccessories?: boolean;
  /**
   * Which slots to randomize. Other slots use default parts.
   */
  slotsToRandomize?: BotPartSlot[];
};

export const DEFAULT_BOT_SPINE_CDN_OPTIONS: SpineFromOptions = {
  atlas: 'https://staticcontent.knowledgehook.com/content/khg/bot/v9/player_bot.atlas',
  skeleton: 'https://staticcontent.knowledgehook.com/content/khg/bot/v9/player_bot.json'
};

export const DEFAULT_BOT_TEAM_COLOR: TeamColorAssignment = {
  name: 'lightBlue',
  colour: [...TeamIdAndColorMap[0]]
};

/** Explicit opt-in to manifest bundle instead of CDN defaults. */
export const MANIFEST_BOT_SPINE = 'manifest' as const;

export type BotSpineSource = SpineFromOptions | typeof MANIFEST_BOT_SPINE;
